// extracted by mini-css-extract-plugin
export default {"root":"ButtonIcon-root-f3772aedff8f66848665c45939aa05e6"};